<template>
  <div class="row">
    <div class="form-group col-md-3">
      <w-input :model="model.hour" :title="$t(model.hour.$schema.title)" />
    </div>

    <div class="form-group col-md-3">
      <w-input :model="model.minute" :title="$t(model.minute.$schema.title)" />
    </div>

    <div class="form-group col-md-3">
      <w-input :model="model.second" :title="$t(model.second.$schema.title)" />
    </div>

    <div class="form-group col-md-3">
      <w-input :model="model.hundredth" :title="$t(model.hundredth.$schema.title)" />
    </div>
  </div>
</template>

<script>
import WInput from '@witkac/bootstrap4-components/src/components/input.vue';

// @vuese
// Component do wprowadzania jednostki czasu
// @group Components
export default {
  props: {
    // Model wyniku
    model: {
      type: Object,
      required: true
    }
  },
  components: {
    WInput
  }
};
</script>
